import { createContext, useContext } from 'react';
export var NavigatorContext = /*#__PURE__*/createContext({});
export var useNavigatorContext = function () {
  return useContext(NavigatorContext);
};